export default __webpack_public_path__ + "static/media/icon-customer-search.cde07f02.svg";